export default __webpack_public_path__ + "static/media/blackline.8e334447.jpg";